/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import { Box, Typography } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";
import ModalityIconImg from "../../../MainPage/ModalityIconImg";
import { StopPlace } from "../types";

export interface StopPlaceBreadcrumbProps {
  stopPlace: StopPlace;
}

/**
 * Stop place context row shown at the top of QuayPanel/ParkingPanel.
 * Mirrors StopPlaceHeader's modality icon and id caption styling.
 */
export const StopPlaceBreadcrumb: React.FC<StopPlaceBreadcrumbProps> = ({
  stopPlace,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        px: 1.5,
        py: 0.75,
        gap: 0.5,
        bgcolor: "background.default",
        flexShrink: 0,
      }}
    >
      <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
        <ModalityIconImg
          type={stopPlace.stopPlaceType || "other"}
          submode={stopPlace.submode}
          svgStyle={{ width: 14, height: 14 }}
        />
      </Box>
      <Typography variant="caption" color="text.secondary" noWrap>
        {stopPlace.name || formatMessage({ id: "new_stop_title" })}
      </Typography>
      {stopPlace.id && (
        <Typography
          variant="caption"
          color="text.primary"
          noWrap
          sx={{ ml: 0.25 }}
        >
          · {stopPlace.id}
        </Typography>
      )}
    </Box>
  );
};
